import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreLabel = '查看更多',
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-start gap-3 min-w-0">
        <span className="mt-0.5 w-9 h-9 shrink-0 rounded-md bg-primary-500/12 flex items-center justify-center text-primary-400">
          <i className={`${icon} text-lg`} />
        </span>
        <div className="min-w-0">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-primary-400 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}